import React, { PropsWithChildren } from 'react';
import { NoticeStyle } from './style';

const Notice = (props: PropsWithChildren<object>) => {
  const { children } = props;

  return <NoticeStyle>{children}</NoticeStyle>;
};

export default Notice;
